/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputDateRange/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Trigger from './Trigger/index'
import TysiaDateRange from './TysiaDateRange/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputDateRange({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange",
  offsetCrossAxis,
  offsetMainAxis,
  disabled,
  required,
  size,
  daterange,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  width,
  maxWidth,
  label,
  onSave
  
}) {
let rangesDateRangeValueData = fromData.useDataValue({ viewPath,
context: 'ranges',
path: 'date_range',
})
let rangesTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'ranges',
path: 'templates',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  offsetCrossAxis,
  offsetMainAxis,
  disabled,
  required,
  size,
  daterange,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  width,
  maxWidth,
  label,
  onSave
  
})
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 offsetCrossAxis={offsetCrossAxis}
 offsetMainAxis={offsetMainAxis}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
 disabled={disabled}
>
{childProps => (
<Trigger
{...childProps}
  viewPath={`${viewPath}/Trigger`}
 required={required}
 size={size}
 daterange={daterange}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 width={width}
 maxWidth={maxWidth}
 label={label}
/>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<TysiaDateRange
{...childProps}
  viewPath={`${viewPath}/TysiaDateRange`}
 data="ranges.date_range"
 value={rangesDateRangeValueData}
 onChange={onChange}
 onSave={onSave}
 data="ranges.templates"
 rangeTemplates={rangesTemplatesValueData}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}